export default __webpack_public_path__ + "static/media/电导率EC探头.3a4081ca.jpg";